"use client";
import { type Editor, useEditorState } from "@tiptap/react";
import { useEditorContext } from "./EditorProvider";

export function WordCount(props: {
  className?: string;
  prefix?: string;
  suffix?: string;
}) {
  const { editor } = useEditorContext();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor | null }) => ({
      wordCount: editor?.storage.characterCount.words(),
    }),
  });

  if (!editor) {
    return null;
  }

  if (!editorState) {
    return null;
  }

  return (
    <span className={props.className}>
      {props.prefix ?? ""}
      {editorState.wordCount}
      {props.suffix ?? ""}
    </span>
  );
}

export function ShowOnlyIfEditorIsEmpty(props: { children: React.ReactNode }) {
  const { editor } = useEditorContext();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor | null }) => ({
      wordCount: editor?.storage.characterCount.words(),
    }),
  });

  console.log("editorState", editorState?.wordCount);

  if (!editor) {
    return null;
  }

  if (!editorState) {
    return null;
  }

  if (editorState.wordCount === undefined || editorState.wordCount > 0) {
    return null;
  }

  return <>{props.children}</>;
}
